var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heightWaybill"},[_c('height-waybill-tabs'),_c('height-waybill-container')],1)}
var staticRenderFns = []

export { render, staticRenderFns }